import withModal from 'src/hoc/withModal'

import RefreshNominationsDialog from './RefreshNominationsDialog'

export default withModal(RefreshNominationsDialog)
